(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const initialized = new WeakSet();
    let resizeFrame = null;

    const getElements = (component) => {
      const container = component.querySelector(':scope > slideshow-container');

      if (!container) {
        return {};
      }

      const track = container.querySelector(':scope > slideshow-slides');

      return {
        container,
        track
      };
    };

    const getActiveSlide = (component, track) => {
      if (!track) {
        return null;
      }

      const slides = Array.from(track.children).filter(
        (element) => element.tagName.toLowerCase() === 'slideshow-slide'
      );

      if (!slides.length) {
        return null;
      }

      const availableSlides = slides.filter(
        (slide) => !slide.hasAttribute('hidden') || slide.hasAttribute('reveal')
      );

      if (
        typeof component.current === 'number' &&
        availableSlides[component.current]
      ) {
        return availableSlides[component.current];
      }

      return (
        availableSlides.find(
          (slide) => slide.getAttribute('aria-hidden') === 'false'
        ) ||
        availableSlides[0] ||
        slides[0]
      );
    };

    const clearHeight = (component) => {
      const { container, track } = getElements(component);

      if (container) {
        container.style.removeProperty('height');
      }

      if (track) {
        track.style.removeProperty('height');
      }
    };

    const updateHeight = (component) => {
      if (!component.isConnected) {
        return;
      }

      if (!mobileQuery.matches) {
        clearHeight(component);
        return;
      }

      const section = component.closest(
        '.slideshow-section--fit-media-mobile'
      );

      if (!section) {
        clearHeight(component);
        return;
      }

      const { container, track } = getElements(component);

      if (!container || !track) {
        return;
      }

      const activeSlide = getActiveSlide(component, track);

      if (!activeSlide) {
        return;
      }

      const height = Math.ceil(activeSlide.getBoundingClientRect().height);

      if (!height || height < 1) {
        return;
      }

      const heightValue = `${height}px`;

      if (track.style.height !== heightValue) {
        track.style.height = heightValue;
      }

      if (container.style.height !== heightValue) {
        container.style.height = heightValue;
      }
    };

    const scheduleUpdate = (component) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateHeight(component);
        });
      });
    };

    const initialize = (component) => {
      if (initialized.has(component)) {
        scheduleUpdate(component);
        return;
      }

      initialized.add(component);

      const observer = new MutationObserver((mutations) => {
        const relevantMutation = mutations.some(
          (mutation) =>
            mutation.type === 'attributes' &&
            (
              mutation.attributeName === 'aria-hidden' ||
              mutation.attributeName === 'aria-selected'
            )
        );

        if (relevantMutation) {
          scheduleUpdate(component);
        }
      });

      observer.observe(component, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-selected']
      });

      component.addEventListener(
        'load',
        (event) => {
          const target = event.target;

          if (
            target instanceof HTMLImageElement &&
            target.closest('slideshow-slide')
          ) {
            scheduleUpdate(component);
          }
        },
        true
      );

      component.addEventListener(
        'loadedmetadata',
        (event) => {
          const target = event.target;

          if (
            target instanceof HTMLVideoElement &&
            target.closest('slideshow-slide')
          ) {
            scheduleUpdate(component);
          }
        },
        true
      );

      scheduleUpdate(component);

      setTimeout(() => {
        scheduleUpdate(component);
      }, 100);

      setTimeout(() => {
        scheduleUpdate(component);
      }, 500);
    };

    const initializeAll = (root = document) => {
      const selector =
        '.slideshow-section--fit-media-mobile slideshow-component';

      if (root instanceof Element && root.matches(selector)) {
        initialize(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(selector).forEach(initialize);
      }
    };

    const updateAll = () => {
      document
        .querySelectorAll(
          '.slideshow-section--fit-media-mobile slideshow-component'
        )
        .forEach(scheduleUpdate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAll();
      });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    window.addEventListener('resize', () => {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        updateAll();
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateAll);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
